var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSettingFill = function SvgIcSettingFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.416 13.6c.4.2.6.5.8.8.4.6.3 1.4 0 2.1l-.7 1.2c-.6 1-1.9 1.3-2.9.7-1.2-.7-2.8.3-2.8 1.6 0 1.1-.9 2-2.1 2h-1.4c-1.2 0-2.1-.9-2.1-2 0-1.3-1.6-2.3-2.8-1.6-1 .6-2.3.3-2.9-.7-.6-.9-1.5-2.2-.7-3.2.2-.3.5-.6.8-.8.3-.1.5-.4.6-.6.5-.9.2-2-.7-2.5-1-.6-1.3-1.8-.8-2.8l.7-1.2c.6-1 1.9-1.3 2.9-.8.9.5 2 .2 2.6-.7.4-.7.1-1.5.6-2.1.4-.6 1.1-1 1.8-1h1.4c.8 0 1.4.4 1.8 1 .5.6.1 1.4.5 2 .5.8 1.7 1.2 2.6.7 1-.6 2.3-.2 2.9.8l.7 1.2c.6 1 .3 2.3-.8 2.8-1.2.6-1.2 2.4 0 3.1M9.116 12c.1 3.7 5.7 3.7 5.8 0-.1-3.7-5.7-3.7-5.8 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcSettingFill;